export default __webpack_public_path__ + "static/media/P107.1.95673621.mp3";